import { SyllabusDetailResponse } from '@nimbly-technologies/nimbly-common';
import { createAsyncAction } from 'typesafe-actions';
import * as types from './syllabuses.actionTypes';

export const fetchLmsSyllabusesByIdAsync = createAsyncAction(
	types.FETCH_LMS_SYLLABUSES_BY_ID_REQUEST,
	types.FETCH_LMS_SYLLABUSES_BY_ID_SUCCESS,
	types.FETCH_LMS_SYLLABUSES_BY_ID_FAILURE,
)<string, SyllabusDetailResponse, string>();
